<template>
    <v-list>
        <div
            v-if="
                !record.isSingleResults &&
                record.output &&
                record.output.arupComputeResultItems
            "
        >
            <v-list-item
                v-for="(r, i) in record.output.arupComputeResultItems"
                :key="i"
                class="d-flex"
            >
                <v-list-item-title>
                    <span
                        v-katex:auto="{
                            options: katexOptions,
                        }"
                        v-if="r.html"
                        v-html="r.html"
                    />
                    <span v-else>
                        <span
                            v-katex:auto="{
                                options: katexOptions,
                            }"
                            v-html="getKaTeX(r).html"
                        />
                    </span>
                </v-list-item-title>
                <v-list-item-subtitle>
                    <p class="text-medium-emphasis" style="text-wrap: wrap">
                        {{ getKaTeX(r).description }}
                    </p>
                </v-list-item-subtitle>
            </v-list-item>
        </div>
        <div v-else>
            <p v-if="record && record.output && record.output.result">
                <span v-if="record.isSingleFileResults"
                    >See Files tab for outputs</span
                >
                <span v-else class="text-body-large"
                    >Result: {{ record.output.result }}</span
                >
            </p>
            <p v-else>No text results</p>
        </div>
    </v-list>
</template>
<script setup>
import { ref } from 'vue'

const props = defineProps({
    record: {
        type: Object,
        required: true,
    },
    calc: {
        type: Object,
        required: true,
    },
})

const katexOptions = ref({
    delimiters: [{ left: '$$', right: '$$', display: false }],
})

function getKaTeX(ri) {
    let r = structuredClone(ri)

    if (props.calc.outputs) {
        for (const output of props.calc.outputs) {
            if (output.name == r.symbol) {
                r.symbol = output.name
                r.latex = output.latex
                r.description = output.description
                r.units = output.units
            }
        }
    }

    if (!r.units) {
        r.units = ''
    }

    if (!r.symbol) {
        r.symbol = '?'
    }

    if (!r.latex) {
        if (r.laTeX) {
            r.latex = r.laTeX
        } else {
            r.latex = r.symbol
        }
    }

    let html = `$$${r.latex} = $$ ${r.value} $$\\, ${r.units}$$`

    return { html: html, description: r.description }
}
</script>
